/**
 * Empty-state shown to a staff member who is authenticated (a valid
 * @prerender.io session) but whose JWT carries no recognised staff tier
 * (COR-545). Rather than letting them into the tools only to hit a wall of
 * backend 403s, we surface a single clear "request access" message.
 */
const RequestAccess = (): JSX.Element => {
  return (
    <main className="container text-center py-6">
      <h1 className="mb-3">You don't have access yet</h1>
      <p className="text-muted">
        Your account isn't assigned a staff role. Please request access from an
        admin to use the internal tools.
      </p>
    </main>
  );
};

export default RequestAccess;
